import { render, staticRenderFns } from "./SektorTimer.vue?vue&type=template&id=1223748c&"
import script from "./SektorTimer.vue?vue&type=script&lang=js&"
export * from "./SektorTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports